import { render } from "./RequestPasswordReset.vue?vue&type=template&id=517b8a64&scoped=true"
import script from "./RequestPasswordReset.vue?vue&type=script&lang=js"
export * from "./RequestPasswordReset.vue?vue&type=script&lang=js"

import "./RequestPasswordReset.vue?vue&type=style&index=0&id=517b8a64&scoped=true&lang=css"

import exportComponent from "/builds/sites/smolke/app-kwispelcoach-com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-517b8a64"]])

export default __exports__